import React, {useLayoutEffect} from 'react';

import {Route, Switch, useLocation} from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';




// Components
import Home from './pages/home';
import DashBoard from './pages/dashboard';
import Error404 from './pages/errors/Error404';

import PublicRoute from './utils/PublicRoute';
import PrivateRoute from './utils/PrivateRoute';
import ReturnsList from './pages/returnsList';
import SearchBarcode from './Components/searchBarcode';
import forgotPassword from './pages/forgotPassword';
import createUser from './pages/createUser';
import resetPassword from './pages/resetPassword';
import RefillTime from './pages/RefillTime';
import CreatePatient from './pages/createPatient';
import PatientList from './pages/patientList';
import NonFormList from './pages/nonFormList';
import NonFormListSuggestion from './pages/nonFormListSuggestion';
import CreateStatMeds from './pages/CreateStatMeds'

import MARDrugs from './pages/marDrugsList';
import returnForm from './Components/returnForm';
import UsersList from './pages/usersList';
import DiseaseStateList from './pages/diseaseStateList';
import CreateDrug from './pages/createDrug';
import Master from './pages/master';
import CreateMaster from './pages/createMaster';
import Census from './pages/census';
import UnitCost from './pages/unitCost';
import EditUnitCost from './pages/editUnitCost';
import CreateCensus from './pages/createCensus';
import EOM from './pages/EOM';
import EOMFiles from './pages/EOMFiles';
import Ssrs from './pages/Ssrs';
import Delivery from './pages/delivery'
import kopForm from './Components/kopForm';
import expirationReport from './Components/expirationReport';
import expirationPublish from './Components/expirationPublish';
import managementFileUpload from './pages/managementFileUpload';
import managementReportDownld from './pages/managementReportDownld';
import managementReport from './pages/managementReport';
import orderEntryDashboard from './pages/orderEntryDashboard';
import shipingScan from './pages/shipingScan';
import PublishList from './pages/publishList';
import ShipingReport from './pages/shipingReport';
import Stocks from './pages/Stock';
import StockOrder from './pages/StockOrder';
import FLStockOrderForm from './pages/FLStockOrderForm';
import FLStockOrder from './pages/FLStockOrder';
import ApprovalQue from './pages/ApprovalQue';
import StocksReports from './pages/StocksReport';
import CopyDrugs from './pages/copyDrugs';
import PatientDetails from  './pages/patientDetails';
import GenerateSsrs from './pages/generateSsrs';
import InvoiceList from './pages/invoiceList';
import InvoiceSrn from './pages/invoiceSrn';
import UploadDocuments from './pages/uploadDocuments';
import DocumentList from './pages/documentList';
import CoreCivicFormula from './pages/CoreCivicFormula';
import CreateFormula from './pages/createFormula';
import PriceCodes from './pages/priceCode';
import CreatePriceCode from './pages/createPriceCode';
import PriceMatch from './pages/priceMatch';
import CreatePriceMatch from './pages/createPriceMatch';
import AnyZeros from './pages/anyZeros';
import CreateAnyZeros from './pages/createAnyZeroes';
import CreateOrder from './pages/createOrder';
import Refill from './pages/Refill';
import ReleaseMedication from './pages/ReleaseMedication';
import RenewMedication from './pages/ReleaseMedication/RenewMedication';
import ClaimSubmission from './pages/ClaimSubmission';
import ReplacementsAndReturns from './pages/ReplacementsAndReturns';
import FlowRackInventory from './pages/FlowRackInventory';
import RefillsDue from './pages/RefillsDue';
import FacilityRefillsDue from './pages/FacilityRefillsDue';
import MedicationHistory from './pages/MedicationHistory';
import ConfigureMedpass from './pages/ConfigureMedpass';
import MedpassAdministration from './pages/MedpassAdministration';
import KOPAdministration from './pages/KOPAdministration';
import Clarifications from './pages/Clarifications';
import AddOnsPage from './pages/addons';
import UpdateEOMDataPage from './pages/uploadEOMData';
import SorterScanRXNumber from './pages/sorterscan';  
import InvalidOrderDrugReport from './pages/InvalidOrderDrugReport';
import AddendumMedpassAdministration from './pages/addendumAdministration';
import EpcisViewer from './pages/EpcisViewer';
import EpcisFileDetails from './pages/EpcisFileDetails';
import HelpVideos from './Components/HelpVideos';

const Routes = () => {
  //const token = user ? user?.token : false;
  let location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Switch>

      <PublicRoute exact path='/' component={Home}/>
      <PublicRoute path="/login/callback" component={LoginCallback}/>
      <PublicRoute path='/forgotpassword' component={forgotPassword}/>
      <PublicRoute path='/ResetPassword' component={resetPassword}/>
      <PrivateRoute path='/dashboard' component={DashBoard}/>
      <PrivateRoute path='/returns' component={ReturnsList}/>
      <PrivateRoute path='/refill' component={Refill}/>
      <PrivateRoute path='/refillDue' component={RefillsDue}/>
      <PrivateRoute path='/faciltyRefillDue' component={FacilityRefillsDue}/>
      <PrivateRoute path='/nonforms' component={NonFormList}/>
      <PrivateRoute path='/nonformsSuggestion' component={NonFormListSuggestion}/>
      <PrivateRoute path='/create-user' component={createUser}/>
      <PrivateRoute path='/edit-user/:userId' component={createUser}/>
      <PrivateRoute path='/barcode-search' component={SearchBarcode}/>
      <PrivateRoute path='/returnForm' component={returnForm}/>
      <PrivateRoute path='/priceCode' component={PriceCodes}/>
      <PrivateRoute path='/edit-priceCode/:id' component={CreatePriceCode}/>
      <PrivateRoute path='/create-priceCode' component={CreatePriceCode}/>
      <PrivateRoute path='/priceMatch' component={PriceMatch}/>
      <PrivateRoute path='/edit-priceMatch/:id' component={CreatePriceMatch}/>
      <PrivateRoute path='/create-priceMatch' component={CreatePriceMatch}/>
      <PrivateRoute path='/anyZeros' component={AnyZeros}/>
      <PrivateRoute path='/edit-anyZeros/:id' component={CreateAnyZeros}/>
      <PrivateRoute path='/create-anyZeros' component={CreateAnyZeros}/>
      <PrivateRoute path='/marDrugs' component={MARDrugs}/>
      <PrivateRoute path='/census' component={Census}/>
      <PrivateRoute path='/unitcost' component={UnitCost}/>
      <PrivateRoute path='/edit-unitcost/:id' component={EditUnitCost}/>
      <PrivateRoute path='/diseaseState' component={DiseaseStateList}/>
      <PrivateRoute path='/create-drug' component={CreateDrug}/>
      <PrivateRoute path='/create-census' component={CreateCensus}/>
      <PrivateRoute path='/edit-census/:id' component={CreateCensus}/>
      <PrivateRoute path='/edit-drug/:id' component={CreateDrug}/>
      <PrivateRoute path='/corecivic' component={CoreCivicFormula}/>
      <PrivateRoute path='/create-formula' component={CreateFormula}/>
      <PrivateRoute path='/edit-formula/:id' component={CreateFormula}/>
      <PrivateRoute path='/eom' component={EOM}/>
      <PrivateRoute path='/eomFiles' component={EOMFiles}/>
      <PrivateRoute path='/master' component={Master}/>
      <PrivateRoute path='/create-facility' component={CreateMaster}/>
      <PrivateRoute path='/edit-facility/:id' component={CreateMaster}/>

      <PrivateRoute path='/users' component={UsersList}/>
      <PrivateRoute path='/ssrs/:type' component={Ssrs}/>
      <PrivateRoute path='/generateSsrs' component={GenerateSsrs}/>

      <PrivateRoute path='/delivery' component={Delivery}/>
      <PrivateRoute path='/patients' component={PatientList}/>
      <PrivateRoute path='/createPatient' component={CreatePatient}/>
      <PrivateRoute path='/patient/:id' component={CreatePatient}/>
      <PrivateRoute path='/uploadDocuments' component={UploadDocuments}/>
      <PrivateRoute path='/documents' component={DocumentList}/>
      <PrivateRoute path='/refillTime' component={RefillTime}/>
      <PrivateRoute path='/createOrder' component={CreateOrder}/>

      <PrivateRoute path='/medpass' component={MedpassAdministration}/>      
      <PrivateRoute path='/medhistory' component={MedicationHistory}/>
      <PrivateRoute path='/configure' component={ConfigureMedpass}/>
      <PrivateRoute path='/kop' component={KOPAdministration}/>
      
      <PrivateRoute path='/forms/:kopForm' component={kopForm}/>
      <PrivateRoute path='/forms/:rmf' component={kopForm}/>
      <PrivateRoute path='/expirationReport' component={expirationReport}/>
      <PrivateRoute path='/expirationPage' component={expirationPublish}/>
      <PrivateRoute path='/managementFileUpload' component={managementFileUpload}/>
      <PrivateRoute path='/managementReportDownld' component={managementReportDownld}/> 
      <PrivateRoute path='/managementReport' component={managementReport}/> 
      <PrivateRoute path='/orderEntryDashboard' component={orderEntryDashboard}/> 
      <PrivateRoute path='/shipingScan' component={shipingScan}/> 
      <PrivateRoute path='/publishList' component={PublishList}/>  
      <PrivateRoute path='/shipingReport' component={ShipingReport}/>  
      <PrivateRoute path='/stocks' component={Stocks}/>
      <PrivateRoute path='/stockOrder' component={StockOrder}/>
      <PrivateRoute path='/flStockOrderForm' component={FLStockOrderForm}/>
      <PrivateRoute path='/FLStockOrder' component={FLStockOrder}/>
      <PrivateRoute path='/approvalQue' component={ApprovalQue}/>
      <PrivateRoute path='/stocksReports' component={StocksReports}/>
      <PrivateRoute path='/copyDrugs' component={CopyDrugs}/>
      <PrivateRoute path='/patientDetails' component={PatientDetails}/>
      <PrivateRoute path='/invoiceList' component={InvoiceList}/> 
      <PrivateRoute path='/invoice' component={InvoiceSrn}/>
      <PrivateRoute path='/releaseMedication' component={ReleaseMedication} />      
      <PrivateRoute path='/renewMedication' component={RenewMedication} />      
      <PrivateRoute path='/claimSubmission' component={ClaimSubmission} />      
      <PrivateRoute path='/replacements' component={ReplacementsAndReturns} />      
      <PrivateRoute path='/createStatMeds' component={CreateStatMeds} />      
      <PrivateRoute path='/flowrackinventory' component={FlowRackInventory} />

      {/* clarifications route */}
      <PrivateRoute path='/clarifications' component={Clarifications} />

      {/* EOM Add-Ons route */}
      <PrivateRoute path='/eom-addons' component={AddOnsPage}/>

      {/* Update EOM Data route */}
      <PrivateRoute path='/eom-update' component={UpdateEOMDataPage} />

      {/* Sorter Scan route */}
      <PrivateRoute path='/sorterscan' component={SorterScanRXNumber} />
      
      {/* Sorter Scan route */}
      <PrivateRoute path='/invalidOrderDrug' component={InvalidOrderDrugReport} />

      {/* Addendum route */}
      <PrivateRoute path='/addendum-medpass' component={AddendumMedpassAdministration} />

      {/* EPCIS File Details — must come BEFORE /epcis-viewer so :id is matched first */}
      <PrivateRoute path='/epcis-viewer/:id' component={EpcisFileDetails} />

      {/* EPCIS Viewer */}
      <PrivateRoute path='/epcis-viewer' component={EpcisViewer} />
      
      {/* Help & How-To Videos — accessible to all roles */}
      <PrivateRoute path='/help' component={HelpVideos} />

      {/* fall back */}
      <Route path='*'>
        <NoMatch/>
      </Route>
    </Switch>
  );
};

export default Routes;

// 404 basic function
function NoMatch() {
  return <Error404/>;
}
